import { LocalizationService } from '@abp/ng.core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { SelectorComponent } from 'src/ca-shared/selector/selector.module';
import { Operators } from 'src/core/models/request/operator.enum';
import { PermissionSelectionConfigurationModel } from '../models/permission-selection-configuration.model';
import { PermissionDefinitionDto } from 'src/core/models/permission/permission-definition.dto';

@Component({
  selector: 'ca-permission-selection-panel',
  templateUrl: './permission-selection-panel.component.html',
  styleUrl: './permission-selection-panel.component.scss',
  standalone: false,
})
export class PermissionSelectionPanelComponent
  extends FilterPanelEditorComponent
  implements OnInit
{
  actualConfig: PermissionSelectionConfigurationModel;

  _value: PermissionDefinitionDto[];
  permissionSelectorOptions: any;

  @ViewChild(SelectorComponent, { read: SelectorComponent })
  permissionSelector: SelectorComponent;

  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as PermissionSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  set value(value: any) {
    this.editorForm.patchValue({
      editor: value,
    });
  }

  get value(): any {
    return this._value;
  }

  constructor(
    private localizationService: LocalizationService,
    private operators: Operators,
    protected fb: FormBuilder
  ) {
    super(fb);

    this.permissionSelectorOptions = {
      pageSize: 5,
      queryOperator: this.operators.Contains,
      queryField: 'quickSearchTerm',
      emptyText: this.localizationService.instant('::SelectPermission'),
      multiple: true,
      url: 'api/app/permission',
      currentPage: 1,
      showSelections: false,
      showClearSelections: false,
      showClearSelectionLink: true,
      selectorPosition: 'Top',
    };

    this.editorForm.valueChanges.subscribe(val => {
      this._value = val.editor;
      this.onChange();
    });
  }

  ngOnInit(): void {}

  reload(): void {}

  reset(): void {}

  autoSelectFirstItem(): void {}

  init() {
    super.init();
    if (this.actualConfig.autoLoad) {
      this.permissionSelector.refresh();
    }
  }
}
